import axiosInstance from "../../../axiosInstance";
import { updateLinks } from "../../../redux/features/nodes";
import { pollForTaskResult } from "../../../redux/api/api.graph"; 
import { updateNodeLabel } from "../../../redux/features/nodes";
import { setRoomNameMapping } from "../../../redux/features/graph/graph.slice";

export default async function applyPtpgGraph({
  nodes,
  links,
  plotWidth,
  plotHeight,
  isDimensioned,
  dispatch,
}: {
  nodes: any[];
  links: any[];
  plotWidth?: number | null;
  plotHeight?: number | null;
  isDimensioned?: boolean;
  dispatch: any;
}) {
  try {
    const vpWidth = window.visualViewport?.width || window.innerWidth || 1;
    const vpHeight = window.visualViewport?.height || window.innerHeight || 1;

    const normalizedNodes = nodes.map((n: any) => {
      const baseNode = {
        ...n,
        roomtype: n.roomtype ?? "Others",
        x: typeof n.x === "number" ? n.x / vpWidth : 0,
        y: typeof n.y === "number" ? n.y / vpHeight : 0,
      };
      if (isDimensioned) {
        return {
          ...baseNode,
          width: {
            min: n.width?.min ?? 3,
            max: n.width?.min ?? 3,
          },
          height: {
            min: n.height?.min ?? 3,
            max: n.height?.min ?? 3,
          },
          ratio: {
            min: n.ratio?.min ?? 3,
            max: n.ratio?.min ?? 3,
          },
        };
      }
      return baseNode;
    });

    const normalizedEdges = links.map((l: any) => ({
      ...l,
      color: l.color || "black",
    }));

    const payload = {
      rectangular: true,
      corridor: false,
      dimensioned: isDimensioned ?? false,
      non_adj: false,
      dimensionedCirculation: isDimensioned ?? false,
      minDimEnabled: true,
      removeAddCirculation: false,
      publicEnabled: false,
      normalizeConst: true,
      limit: 10,
      corridorThickness: 0.5,
      starting_from: 0,
      count: nodes.length,
      nodes: normalizedNodes,
      edges: normalizedEdges,
      plot_width: plotWidth ?? vpWidth,
      plot_height: plotHeight ?? vpHeight,
    };

    console.log("PTPG payload:", payload);

    const res = await axiosInstance.post(
      "/api/generate/door_connectivity",
      payload
    );

    const taskId = res.data?.task_id;

    if (!taskId) {
      console.error("No task_id returned from backend", res.data);
      return;
    }

    console.log("Received task_id:", taskId);

    const resultData = await pollForTaskResult(taskId);

    console.log("Final task result:", resultData);
    console.log("room_name_mapping:", resultData?.room_name_mapping);
console.log("nodes at time of mapping:", nodes.map((n: any) => ({ id: n.id, label: n.label })));

    const ptpgMatrix =
      resultData?.response?.Documents?.ptpg_graph;

    if (!ptpgMatrix || !Array.isArray(ptpgMatrix)) {
      console.error("PTPG matrix missing in task result", resultData);
      return;
    }

    console.log("Extracted PTPG Matrix:", ptpgMatrix);

    const nodeIds = nodes.map((n: any) => n.id);
    const matrixEdges: any[] = [];

    for (let i = 0; i < ptpgMatrix.length; i++) {
      for (let j = i + 1; j < ptpgMatrix.length; j++) {
        if (Number(ptpgMatrix[i][j]) === 1) {
          matrixEdges.push({
            source: nodeIds[i],
            target: nodeIds[j],
            color: "black",
          });
        }
      }
    }

    const matrixKeySet = new Set(
      matrixEdges.map((e) =>
        [Math.min(e.source, e.target), Math.max(e.source, e.target)].join("-")
      )
    );

    const existingKeySet = new Set(
      (links || []).map((l: any) =>
        [Math.min(l.source, l.target), Math.max(l.source, l.target)].join("-")
      )
    );

    const filteredExistingLinks = (links || []).filter((l) => {
      const key = [
        Math.min(l.source, l.target),
        Math.max(l.source, l.target),
      ].join("-");
      return matrixKeySet.has(key);
    });

    const newPtpgEdges = matrixEdges
      .filter((e) => {
        const key = [
          Math.min(e.source, e.target),
          Math.max(e.source, e.target),
        ].join("-");
        return !existingKeySet.has(key);
      })
      .map((e) => ({
        ...e,
        origin: "ptpg",
        color: e.color || "black",
      }));

    const finalLinks = [...filteredExistingLinks, ...newPtpgEdges];

    console.log("Dispatching final PTPG links:", finalLinks);

    // Apply room_name_mapping to update node labels for dimensioned floorplans
    const roomNameMapping = resultData?.room_name_mapping;
      if (roomNameMapping) {
        dispatch(setRoomNameMapping(roomNameMapping));
        nodes.forEach((node: any, index: number) => {
        const mappedName = roomNameMapping[index + 1]; // mapping is 1-indexed
      if (mappedName) {
        dispatch(updateNodeLabel({ id: node.id, label: mappedName }));
    }
  });
}

dispatch(updateLinks(finalLinks));
  } catch (err) {
    console.error("PTPG API error", err);
  }
}
